import React from 'react';
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import UserForm from "../components/UserForm";

const UserManagement = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout >

        {/* Breadcrumb */}
        <Breadcrumb title="User" />

        {/* DashBoardLayerSix */}
        <UserForm />



      </MasterLayout>
    </>
  );
}
export default UserManagement;